import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { t } from "i18next";
import api from "../../../../helpers/api/Api";
import ApiUrls from "../../../../helpers/urls/ApiUrls";
import RouteUrls from "../../../../helpers/urls/RouteUrls";
import UnitValues from "../../../../helpers/constants/UnitValues";
import TimeValues from "../../../../helpers/constants/TimeValues";
import Table from "../../../../components/Tables/Table";
import DeleteButton from "../../../../components/DeleteButton";
import SiteSelectMore from "./components/siteSelectMore";
import EditSite from "./components/edit";
import PagePermBits from "../../../../helpers/constants/PagePermBits";

function SiteManagement() {
  const use_dispatch = useDispatch();
  const [listReload, setListReload] = useState(0);
  const [rows, setRows] = useState([]);
  const columns = [
    { Header: t("site.site_name"), accessor: "name", align: "left" },
    { Header: t("site.management_ip"), accessor: "mgmtip", align: "center" },
    { Header: t("site.anycast"), accessor: "anycast", align: "center" },
    { Header: t("site.cache_size"), accessor: "cachesizenum", align: "center" },
    { Header: t("site.cache_inactive"), accessor: "inactivenum", align: "center" },
    { Header: t("global.edit"), accessor: "edit", align: "center", width: '10%' },
    { Header: t("global.delete"), accessor: "delete", align: "center", width: '10%' },
    { Header: t("global.actions"), accessor: "actions", align: "center", width: '10%' },
  ];

  const setDataList = (data) => {
    const temp_rows = data.map((site) => {
      return (
        {
          name: (<div className="font-weight-bold">{site.name}</div>),
          mgmtip: site.mgmtip,
          anycast: getAnycasts(site.anycast),
          cachesizenum: getCacheSize(site),
          inactivenum: getCacheTime(site),
          edit: (
            <EditSite
              site={site}
              handleCloseModal={handleCloseModal}
            />
          ),
          delete: (
            <DeleteButton
              item={site}
              itemName={t("site.site")}
              deleteUrl={ApiUrls.site.delete}
              handleCloseModal={handleCloseModal}
            />
          ),
          actions: (
             <SiteSelectMore
                site={site}
                handleCloseModal={handleCloseModal}
             />
          )
        }
      )});

    setRows(temp_rows);
  }

  const getCacheSize = (d) => {
    let unit = UnitValues.filter((uv) => uv.value === d.cachesizeunit)[0];
    return <div style={{ direction: 'ltr' }}>{d.cachesizenum} {unit?.name}</div>
  }
  const getCacheTime = (d) => {
    let unit = TimeValues.filter((tv) => tv.value === d.inactiveunit)[0];
    return <div>{d.inactivenum} {unit?.name}</div>
  }

  const getAnycasts = (anycasts) => {
    const anycastArr = anycasts.split(",");
    return (
       <div>
         {anycastArr.map((a, i) => {
           return (
              <div key={`anycast-${i}`}>{a}</div>
           );
         })}
       </div>
    )
  }

  useEffect(() => {
    getDomainsList();
  }, []);

  const getDomainsList = () => {
    api.post(ApiUrls.domain.list, {})
       .then((response) => {
         use_dispatch({
           type: "SET_DOMAIN_LIST",
           payload: response.data.data
         });
       })
       .catch((error) => {});
  }

  const handleCloseModal = () => {
    setListReload(listReload+1);
  }

  return (
    <Table
      columns={columns}
      rows={rows}
      setDataList={setDataList}
      listReload={listReload}
      addUrl={RouteUrls.site.add}
      getListUrl={ApiUrls.site.list}
      itemName={t("site.site")}
      itemPName={t("site.sites")}
      listPermBit={PagePermBits.siteManagement}
    />
  );
}

export default SiteManagement;
